import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background-color: #faf9ff;
  color: #433f52;
  padding: 24px 1rem;
  font-size: ${fontSize('lg')};
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (min-width: ${screen('lg')}) {
    padding: 64px 0;
  }

  .intro {
    margin-bottom: 2rem;

    @media (min-width: ${screen('lg')}) {
      margin-left: auto;
      margin-right: auto;

      &.full {
        max-width: 100%;
      }
    }
  }
`;

const CardContent1 = styled.div`
  background: #92e6d7;
  color: #087273;
  border-radius: 20px;
  padding: 2rem 3rem 1rem 3rem;
  transform: translate(0px, 0px) rotate(2deg);
  border-radius: 45% 25% 45% 25% / 42% 16% 33% 20%;

  > div {
    transform: translate(0px, 0px) rotate(-2deg);
    font-size: ${fontSize('md')};
    text-align: center;
  }

  .title {
    font-size: ${fontSize('lg')};
    text-align: center;
    justify-content: center;

    em {
      background: #087273;
      color: #92e6d7;
      padding: 0.25rem 0.5rem;
      border-radius: 20px;
      text-transform: lowercase;
      font-size: ${fontSize('md')};
      font-weight: bold;
      font-style: normal;
      min-width: 30px;
    }

    strong {
      min-width: 80%;
    }

    span {
      min-width: 80%;
    }

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('xl')};

      span {
        text-align: left;
      }

      strong {
        text-align: right;
      }
    }
  }
`;

export const TalentRecruitingStyles = {
  Root,
  CardContent1
};
